<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="70%">
      <v-card>
        <v-card-title>
          <span class="text-h5 align-center">{{ title }}</span>
          <v-col class="d-flex flex-row justify-end">
            <v-btn small @click="loadData" v-show="plan.id">
              <v-icon small title="Buscar">fas fa-search</v-icon>
            </v-btn>
            <v-btn small @click="add" v-show="selected && selected.length">
              <v-icon small title="Adicionar">fas fa-plus</v-icon>
            </v-btn>
            <v-btn small @click="hide">
              <v-icon small title="Fechar">fas fa-window-close</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  dense
                  label="Plano de Referência"
                  type="string"
                  outlined
                  readonly
                  v-model="referencePlan.carrierName"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  dense
                  outlined
                  v-model="plan.id"
                  :items="plans"
                  item-text="description"
                  item-value="id"
                  label="Produto Operadora"
                  :clearable="true"
                  :loading="this.plans.length == 0"
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item.productCode }}-{{ data.item.description }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-data-table
              dense
              v-model="selected"
              :headers="headers"
              :items="items"
              :options.sync="options"
              :server-items-length="totalElements"
              :loading="isSearching"
              item-key="id"
              locale="pt-BR"
              show-select
              class="elevation-1 mt-2"
              :single-select="single"
            >
              <template v-slot:item.active="{item}">{{
                item.active ? 'Sim' : 'Não'
              }}</template>
              <template v-slot:item.currentPlan="{item}">{{
                  item.currentPlan ? `${item.currentPlan.productCode}-${item.currentPlan.description}` : ``
              }}</template>
              <template v-slot:item.referencePlan="{item}">{{
                  item.referencePlan ? `${item.referencePlan.productCode}-${item.referencePlan.description}` : ``
              }}</template>
              <template v-slot:item.proposalPlanOne="{item}">{{
                  item.proposalPlanOne ? `${item.proposalPlanOne.plan.productCode}-${item.proposalPlanOne.plan.description}` : ``
              }}</template>
              <template v-slot:item.proposalPlanTwo="{item}">{{
                  item.proposalPlanTwo ? `${item.proposalPlanTwo.plan.productCode}-${item.proposalPlanTwo.plan.description}` : ``
              }}</template>
              <template v-slot:item.proposalPlanThree="{item}">{{
                  item.proposalPlanThree ? `${item.proposalPlanThree.plan.productCode}-${item.proposalPlanThree.plan.description}` : ``
              }}</template>
              <template v-slot:item.proposalPlanFour="{item}">{{
                  item.proposalPlanFour ? `${item.proposalPlanFour.plan.productCode}-${item.proposalPlanFour.plan.description}` : ``
                }}</template>
              <template v-slot:item.proposalPlanFive="{item}">{{
                  item.proposalPlanFive ? `${item.proposalPlanFive.plan.productCode}-${item.proposalPlanFive.plan.description}` : ``
                }}</template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ProductService from '@/services/odoo/ProductService';
import EquivalenceConfigurationService from '@/services/insurancepricing/EquivalenceConfigurationService';

export default {
  props: {
    referencePlan: {
      type: Object,
    },
    title: {
      type: String,
      require: true,
    },
    single: {
      type: Boolean,
      default: false,
    },
    equivalenceId: {
      type: Number
    }
  },
  data() {
    return {
      dialog: false,
      plans: [],
      plan: {},
      options: {},
      headers: [
        {text: 'Atual', align: 'left', value: 'currentPlan', sortable: false},
        {
          text: 'Referência',
          align: 'left',
          value: 'referencePlan',
          sortable: false,
        },
        {
          text: '1° Proposto',
          align: 'left',
          value: 'proposalPlanOne',
          sortable: false,
        },
        {
          text: '2° Proposto',
          align: 'left',
          value: 'proposalPlanTwo',
          sortable: false,
        },
        {
          text: '3° Proposto',
          align: 'left',
          value: 'proposalPlanThree',
          sortable: false,
        },
        {
          text: '4° Proposto',
          align: 'left',
          value: 'proposalPlanFour',
          sortable: false,
        },
        {
          text: '5° Proposto',
          align: 'left',
          value: 'proposalPlanFive',
          sortable: false,
        },
        {text: 'Início', align: 'center', value: 'startAt', sortable: false},
        {text: 'Fim', align: 'center', value: 'endAt', sortable: false},
        {text: 'Ativo', align: 'center', value: 'isActive', sortable: false},
      ],
      isSearching: false,
      selected: [],
      items: [],
      totalElements: 0,
    };
  },

  async created() {
    this.productService = new ProductService();
    this.equivalenceConfigurationService =
      new EquivalenceConfigurationService();
  },

  watch: {
    options: {
      handler() {
        if (this.plan.id) this.loadData();
      },
      deep: true,
    },
  },
  methods: {
    async loadData() {
      this.isSearching = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      const {data} = await this.equivalenceConfigurationService.findAllByParams(
        {
          referencePlanId: this.plan.id,
          page: page ? page - 1 : 0,
          sortBy:
            sortBy && sortBy.length ? sortBy[0] : 'referencePlanId',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
        },
      );
      let length = data.content.filter(eq => eq.id==this.equivalenceId).length;
      this.items = data.content.filter(eq => eq.id!=this.equivalenceId);
      this.totalElements = data.totalElements-length;
      this.isSearching = false;
    },
    show() {
      this.dialog = true;
      this.productService
        .findByCarrier(this.referencePlan.carrierId)
        .then((result) => {
          this.plans = result.data;
        });
    },

    hide() {
      this.dialog = false;
    },
    add() {
      if (this.single) {
        this.$emit('selected', this.selected[0]);
      } else {
        this.$emit('selected', this.selected);
      }
      this.items = [];
      this.hide();
    },
  },
};
</script>
